module.exports = __webpack_public_path__ + "img/sid.cfe7534c.png";